import { type BloodGlucoseFormContext } from "@/model/BloodGlucoseFormContext"

export type MedicationApiDto = {
  name: string
}

export type Medication = {
  name: string
}

export const toMedication = (dto: MedicationApiDto): Medication => ({
  name: dto.name,
})

export const medicationTimings = ["BREAKFAST", "LUNCH", "DINNER", "BEDTIME"] as const
export type MedicationTiming = (typeof medicationTimings)[number]

export type PrescribedDiabetesMedicationApiDto = {
  name: string
  timing: MedicationTiming[]
}

export type PrescribedDiabetesMedication = {
  name: string
  timing: MedicationTiming[]
}

export const toPrescribedDiabetesMedication = (
  dto: PrescribedDiabetesMedicationApiDto
): PrescribedDiabetesMedication => ({
  name: dto.name,
  timing: dto.timing,
})

export const timingForContext = (context: BloodGlucoseFormContext): MedicationTiming | null => {
  switch (context) {
    case "breakfast":
      return "BREAKFAST"
    case "lunch":
      return "LUNCH"
    case "dinner":
      return "DINNER"
    case "fasting":
      return "BEDTIME"
    default:
      return null
  }
}

export const hasPrescribedMedicationForContext = (
  medications: PrescribedDiabetesMedication[],
  context: BloodGlucoseFormContext
): boolean => {
  const timing = timingForContext(context)
  return timing !== null && medications.some((medication) => medication.timing.includes(timing))
}

export const medicationQuestionTitle = "Did you take your medication?"
